import { apiClient } from "@/api/softphone_api"

export const getAsteriskServerData = async ({commit}, serverId) => {
  const url = `api/pbx/form-asterisk-server/`
  try {
    let res;
    if (serverId) {
      const data = {
        params: {
          server_id: serverId
        }
      }
      res = await apiClient.get(url, data)
    }else{
      res = await apiClient.get(url)
    }
    commit('setAsteriskServerData', res.data)
  } catch (err) {
    console.error('Ha ocurrido este error: ', err);
  }
}

export const getJitsiServerData = async ({commit}, serverId) => {
  const url = 'api/jitsi/form-jitsi-server/'
  try {
    let res;
    if (serverId) {
      const data = {
        params: {
          server: serverId
        }
      }
      res = await apiClient.get(url, data)
    }else{
      res = await apiClient.get(url)
    }
    commit('setJitsiServerData', res.data)
  } catch (err) {
    console.error('Ha ocurrido este error: ', err);
  }
}

export const getJitsiServersList = async({commit}, {page, itemsPerPage, search}) => {
  const url = 'api/jitsi/jitsi-servers-list/'
  try {
    const filters = {
      params: {
        page: page,
        page_size: itemsPerPage,
        search: search
      }
    }
    const res = await apiClient.get(url, filters)
    commit('setJitsiServersList', res.data)
  } catch (err) {
    console.error('Ha ocurrido este error: ', err);
  }
}